const NAME_RE = /^[\p{L}\p{M}][\p{L}\p{M}\s.'-]*$/u;

const MAX = { name: 60, nameLocal: 60, address: 220, addressLocal: 220 };

export function validate(form) {
  const errors = {};

  ["name", "nameLocal"].forEach((field) => {
    const value = (form[field] || "").trim();
    if (!value) return;
    if (value.length > MAX[field]) {
      errors[field] = `Keep this under ${MAX[field]} characters.`;
    } else if (!NAME_RE.test(value)) {
      errors[field] = "Use letters, spaces, apostrophes, hyphens or dots only.";
    }
  });

  ["address", "addressLocal"].forEach((field) => {
    const value = (form[field] || "").trim();
    if (value.length > MAX[field]) {
      errors[field] = `Keep this under ${MAX[field]} characters.`;
    }
  });

  const dob = (form.dob || "").trim();
  if (dob) {
    const parsed = new Date(dob);
    if (Number.isNaN(parsed.getTime())) {
      errors.dob = "Enter a valid date.";
    } else if (parsed > new Date()) {
      errors.dob = "Date of birth cannot be in the future.";
    } else if (parsed < new Date("1900-01-01")) {
      errors.dob = "Date of birth must be on or after 1 January 1900.";
    }
  }

  return errors;
}

export const todayIso = () => new Date().toISOString().slice(0, 10);
